// 客户端调用的环境变量 主要用在axios中
const env = process.env.NEXT_PUBLIC_APP_ENV;
const apiMap = {
  local: 'https://devlist.szlcsc.com',
  dev: 'https://dev-list.szlcsc.com',
  fat: 'https://fatlist.szlcsc.com',
  uat: 'https://uatlist.szlcsc.com',
  pro: 'https://list.szlcsc.com',
};

const wwwBaseURL = {
  local: 'https://devwww.szlcsc.com',
  dev: 'https://dev-www.szlcsc.com',
  fat: 'https://fatwww.szlcsc.com',
  uat: 'https://uatwww.szlcsc.com',
  pro: 'https://www.szlcsc.com',
}[env];

const orderBaseURL = {
  local: 'https://devorder.szlcsc.com',
  dev: 'https://dev-order.szlcsc.com',
  fat: 'https://fatorder-api.szlcsc.com',
  uat: 'https://uatorder-api.szlcsc.com',
  pro: 'https://order-api.szlcsc.com',
}[env];

const baseURL = apiMap[env];
const isLocal = env === 'local';

export { baseURL, wwwBaseURL, orderBaseURL, env, isLocal };
